import { Component, OnInit } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';

@Component({
  selector: 'app-smart-ai-industry',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],
  templateUrl: './smart-ai-industry.component.html',
  styleUrl: './smart-ai-industry.component.scss',
})
export class SmartAIIndustryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
